// src/components/shop/ShopNavbar.jsx

import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CartDropdown from "./CartDropdown";
import { useCart } from "../../context/CartContext";
import { T, F, KAAKAZINI_LOGO } from "../../config/shop";

export default function ShopNavbar({ search, showCart = true }) {
  const navigate = useNavigate();
  const { setIsOpen } = useCart();

  useEffect(() => {
    const body = document.body.style;
    const html = document.documentElement.style;
    body.paddingTop = "0px";
    body.marginTop = "0px";
    html.paddingTop = "0px";

    return () => {
      body.paddingTop = "";
      body.marginTop = "";
      html.paddingTop = "";
      setIsOpen(false);
    };
  }, [setIsOpen]);

  return (
    <>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/css2?family=Raleway:wght@300;400;500;600;700;800&display=swap"
      />

      <style>{`
        *, *::before, *::after { box-sizing: border-box; }
        html { padding-top: 0 !important; margin-top: 0 !important; }
        body { margin: 0 !important; padding-top: 0 !important; }
        #root { padding-top: 0 !important; margin-top: 0 !important; }
        nav.navbar.bg-light, nav.navbar.navbar-light { display: none !important; }

        .km-search-input { border: 1px solid transparent; outline: none; }
        .km-search-input:focus { box-shadow: 0 0 0 2px ${T.yellow} inset; }

        @media (max-width: 600px) {
          .km-nav-inner { gap: 12px !important; padding: 0 12px !important; }
          .km-nav-logo { width: 96px !important; }
        }
      `}</style>

      <header style={{ background: T.black, position: "sticky", top: 0, zIndex: 400 }}>
        <div
          className="km-nav-inner"
          style={{
            maxWidth: 1280,
            margin: "0 auto",
            padding: "0 20px",
            height: 68,
            display: "flex",
            alignItems: "center",
            gap: 24,
          }}
        >
          <div
            role="link"
            tabIndex={0}
            aria-label="Kaakazini home"
            onClick={() => navigate("/")}
            onKeyDown={(e) => {
              if (e.key === "Enter") navigate("/");
            }}
            style={{ cursor: "pointer", display: "flex", alignItems: "center", flexShrink: 0, height: 42 }}
          >
            <img
              className="km-nav-logo"
              src={KAAKAZINI_LOGO}
              alt="Kaakazini"
              style={{ display: "block", width: 132, height: 42, objectFit: "contain", objectPosition: "left center" }}
              onError={(e) => {
                e.currentTarget.style.display = "none";
                const fallback = e.currentTarget.nextElementSibling;
                if (fallback) fallback.style.display = "block";
              }}
            />
            <span
              style={{
                display: "none",
                fontFamily: F.display,
                fontSize: 22,
                fontWeight: 800,
                color: T.white,
                letterSpacing: "-0.01em",
              }}
            >
              Kaakazini
            </span>
          </div>

          {search ? (
            <form
              onSubmit={search.onSubmit}
              style={{ flex: 1, minWidth: 0, display: "flex", maxWidth: 620, height: 42 }}
            >
              <input
                type="text"
                className="km-search-input"
                placeholder="Search products on Kaakazini…"
                aria-label="Search products"
                value={search.value}
                onChange={(e) => search.onChange(e.target.value)}
                style={{
                  flex: 1,
                  minWidth: 0,
                  height: "100%",
                  padding: "0 16px",
                  borderRadius: "2px 0 0 2px",
                  fontFamily: F.body,
                  fontSize: 14,
                  color: T.black,
                  background: T.white,
                }}
              />
              <button
                type="submit"
                aria-label="Search"
                style={{
                  width: 48,
                  height: "100%",
                  flexShrink: 0,
                  background: T.yellow,
                  border: "none",
                  borderRadius: "0 2px 2px 0",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.background = T.yellowDark)}
                onMouseLeave={(e) => (e.currentTarget.style.background = T.yellow)}
              >
                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke={T.black} strokeWidth="2.5" strokeLinecap="round">
                  <circle cx="11" cy="11" r="8" />
                  <path d="M21 21l-4.35-4.35" />
                </svg>
              </button>
            </form>
          ) : (
            <div style={{ flex: 1 }} />
          )}

          {showCart && (
            <div style={{ marginLeft: "auto", flexShrink: 0 }}>
              <CartDropdown />
            </div>
          )}
        </div>
      </header>
    </>
  );
}